import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import StepConfirmationOnboarding from "components/Step/StepConfirmationOnboarding";

export const MembershipStepConfirmationOnboarding = (
  state: MembershipState
) => {
  return (
    <StepConfirmationOnboarding
      {...state}
      readingLevelImage={state.readingLevelBoxImage || undefined}
    />
  );
};

export const MEMBERSHIP_STEP_CONFIRMATION_ONBOARDING: MembershipStep = {
  component: MembershipStepConfirmationOnboarding,
  id: "membership-id-confirmation-onboarding",
  slug: "onboarding-confirmation",
};

export default MembershipStepConfirmationOnboarding;
